import { GridComponent, row, RowDataBoundEventArgs } from "@syncfusion/ej2-angular-grids";
import { VendorScoreCardRowTypeV20 } from "src/app/base/models/models.swagger.generated";

export const VendorScoreCardRowTypeV20Name: string = "rowType";
export const VendorScoreCardWeightedCatName: string = "weightedCat";
export const VendorScoreCardWeightedSubName: string = "weightedSub";
export const VendorScoreCardTenPointsReferenceName: string = "tenPointsReference";
export const VendorScoreCardOnePointReferenceName: string = "onePointReference";
export const VendorScoreCardPointsName: string = "points";
export const VendorScoreCardFactsName: string = "facts";
export const VendorScoreCardWeightedPointsName: string = "weightedPoints";
export const VendorScoreCardTotalPointsCategoryName: string = "totalPointsCategory";

export class VendorScoreCardUtil {
  public static getCategoryHeaderRows(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.MarketSize,
      VendorScoreCardRowTypeV20.SalesStructure,
      VendorScoreCardRowTypeV20.PotentialAndTnC,
      VendorScoreCardRowTypeV20.ProductPortfolio,
      VendorScoreCardRowTypeV20.MarketingPresence
    ];
  }

  public static getCurrencyRows(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.TAM,
      VendorScoreCardRowTypeV20.ProjectedNetRevenue,
      VendorScoreCardRowTypeV20.RevenueGoal
    ];
  }

  public static getCurrencyRowsAdmin(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.TAM,
      VendorScoreCardRowTypeV20.ProjectedNetRevenue,
      VendorScoreCardRowTypeV20.RevenueGoal,
      VendorScoreCardRowTypeV20.CurrentMarketShares,
      VendorScoreCardRowTypeV20.ExpectedGrossProfitMargin
      
    ];
  }

  public static getNumberRows(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.NumberOfActiveResellers,
      VendorScoreCardRowTypeV20.NumberOfDistributors,
      VendorScoreCardRowTypeV20.NumberOfProductCategories,
      VendorScoreCardRowTypeV20.NumberOfProducts,
      VendorScoreCardRowTypeV20.TotalFollowerCount
    ];
  }

  public static getPercentageRows(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.CurrentMarketShares,
      VendorScoreCardRowTypeV20.ShareOfRevenue,
      VendorScoreCardRowTypeV20.PercentageRevenueAllocatedForChannelActivities,
      VendorScoreCardRowTypeV20.ExpectedGrossProfitMargin
    ];
  }

  public static getPercentageRowsAdmin(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.ShareOfRevenue,
      VendorScoreCardRowTypeV20.PercentageRevenueAllocatedForChannelActivities
    ];
  }

  public static getRequiredRows(): VendorScoreCardRowTypeV20[] {
    return [
      VendorScoreCardRowTypeV20.TAM,
      VendorScoreCardRowTypeV20.CurrentMarketShares,
      VendorScoreCardRowTypeV20.NumberOfActiveResellers,
      VendorScoreCardRowTypeV20.NumberOfDistributors,
      VendorScoreCardRowTypeV20.ShareOfRevenue,
      VendorScoreCardRowTypeV20.NumberOfProductCategories,
      VendorScoreCardRowTypeV20.NumberOfProducts,
      VendorScoreCardRowTypeV20.TotalFollowerCount,
      VendorScoreCardRowTypeV20.PercentageRevenueAllocatedForChannelActivities,
      VendorScoreCardRowTypeV20.ExpectedGrossProfitMargin,
      VendorScoreCardRowTypeV20.ProjectedNetRevenue,
      VendorScoreCardRowTypeV20.RevenueGoal,
      VendorScoreCardRowTypeV20.PaymentTerms
    ];
  }

  public static getNonRequiredRows(): VendorScoreCardRowTypeV20[] {
    return [

    ];
  }

  public static getRowsForCategoryHeader(rowType: VendorScoreCardRowTypeV20): VendorScoreCardRowTypeV20[] {
    switch (rowType) {
      case VendorScoreCardRowTypeV20.MarketSize:
        return [
          VendorScoreCardRowTypeV20.TAM,
          VendorScoreCardRowTypeV20.CurrentMarketShares
        ];
      case VendorScoreCardRowTypeV20.SalesStructure:
        return [
          VendorScoreCardRowTypeV20.NumberOfActiveResellers,
          VendorScoreCardRowTypeV20.NumberOfDistributors,
          VendorScoreCardRowTypeV20.ShareOfRevenue
        ];
      case VendorScoreCardRowTypeV20.ProductPortfolio:
        return [
          VendorScoreCardRowTypeV20.NumberOfProductCategories,
          VendorScoreCardRowTypeV20.NumberOfProducts
        ];
      case VendorScoreCardRowTypeV20.MarketingPresence:
        return [
          VendorScoreCardRowTypeV20.TotalFollowerCount,
          VendorScoreCardRowTypeV20.PercentageRevenueAllocatedForChannelActivities
        ];
      case VendorScoreCardRowTypeV20.PotentialAndTnC:
        return [
          VendorScoreCardRowTypeV20.ProjectedNetRevenue,
          VendorScoreCardRowTypeV20.ExpectedGrossProfitMargin,
          VendorScoreCardRowTypeV20.RevenueGoal,
          VendorScoreCardRowTypeV20.PaymentTerms
        ];
      default:
        return [];
    }
  }

  public static extractCellValue(grid: GridComponent, rowIndex: number, columnIndex: number): string {
    try {
      var value = (grid?.getCellFromIndex(rowIndex, columnIndex))?.innerHTML;
    }
    catch {
      return "0";
    }

    var valueStart = value.indexOf('>');
    var valueEnd = value.lastIndexOf('<');
    value = value.slice(valueStart + 1, valueEnd);
    if (value[value.length - 1] == "%") {
      value = value.slice(0, -1);
    }
    else if (value[value.length - 1] == "F") {
      value = value.slice(0, -4);
    }
    return value;
  }

  public static addRowClasses(args: RowDataBoundEventArgs) {
    var rowType = args.data['rowType'];
    if (VendorScoreCardUtil.getCategoryHeaderRows().includes(rowType)) {
      (args.row as Element).classList.add('row-subheader');
    }
    else if (VendorScoreCardUtil.getRequiredRows().includes(rowType)) {
      (args.row as Element).classList.add('row-required');
    }
    else if (VendorScoreCardUtil.getNonRequiredRows().includes(rowType)) {
      (args.row as Element).classList.add('row-non-required');
    }
  }

  public static displayData(data: string, rowType: VendorScoreCardRowTypeV20, columnType: string, isAdmin: boolean): string | null {
    if (data == null) {
      return data;
    }
    if (columnType == VendorScoreCardWeightedSubName ||
      (columnType == VendorScoreCardWeightedCatName && VendorScoreCardUtil.getCategoryHeaderRows().includes(rowType))
    ) {
      return data + "%";
    }
    else if (
      columnType == VendorScoreCardTenPointsReferenceName ||
      columnType == VendorScoreCardOnePointReferenceName ||
      columnType == VendorScoreCardFactsName) {
        var currencyRows = isAdmin ? VendorScoreCardUtil.getCurrencyRowsAdmin() : VendorScoreCardUtil.getCurrencyRows();
        var percentageRows = isAdmin ? VendorScoreCardUtil.getPercentageRowsAdmin() : VendorScoreCardUtil.getPercentageRows();
      if (currencyRows.includes(rowType)) {
        return Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'CHF',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(Number.parseInt(data));
      }
      else if (VendorScoreCardUtil.getNumberRows().includes(rowType)) {
        return Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(Number.parseInt(data))  ;
      }
      else if (percentageRows.includes(rowType)) {
        return data + "%";
      }
    }
    return data;
  }
}